import { Config } from './models';
import { Environment } from '@sunbit-dev/common/services/config';
import { datadogParameters } from './constants';

const mixpanelToken = '2eac08214d56fb463cf511bfbc8a4b7b';

export const baseConfig: Config = {
  apiUrl: null,
  application: 'loan-application',
  mixpanel: {
    proxyURL: 'https://mixpanel-proxy.sunbit.com',
    token: mixpanelToken,
    debug: false,
    optOutTracking: true,
  },
  fingerprintjs: {
    token: 'XNZb6VbuXWRafpnwIsoQ',
    endpoint: 'https://fp.sunbit.in',
  },
  i18n: {
    debug: true,
  },
  sampling: {
    endpoint: 'https://api.sunbit.in/sampling/api/v1/sampling',
  },
};

type EnvironmentsConfigs = {
  [key in Environment]: Partial<Config>;
};

export const environmentsConfigs: EnvironmentsConfigs = {
  dev: {
    apiUrl: 'https://api-master.sunbit.dev/loan-application-service',
    datadog: {
      ...datadogParameters,
      proxy: 'https://api-master.sunbit.dev/application-data/',
    },
    launchDarklyKey: '670feb930c50ac086450478f',
  },
  local: {
    apiUrl: 'http://loan-application-service',
    datadog: {
      ...datadogParameters,
      proxy: 'http://sunbit-api-gateway-public/application-data',
    },
    launchDarklyKey: '670feb930c50ac086450478f',
    launchDarkly: {
      experiment: {
        flagName: 'payment-plans',
      },
    },
    sampling: {
      disabled: true,
      endpoint: 'https://api.sunbit.in/sampling/api/v1/sampling',
    },
  },
  automation: {
    apiUrl: 'https://loan-application-service.automation.sunbit.in',
    launchDarklyKey: '670febc2b4e8ac08371433bb',
  },
  'oregon-demo': {
    apiUrl: 'https://api-demo.sunbit.com/loan-application-service',
    fingerprintjs: {
      token: 'jRJ6Bdd3OtOMWqeOmSiG',
      endpoint: 'https://fp.sunbit.com',
    },
    datadog: {
      ...datadogParameters,
      proxy: 'https://api-demo.sunbit.com/datadog-intake/',
    },
    launchDarklyKey: '670febce7a5d74088dadd3f5',
    sampling: {
      disabled: true,
      endpoint: 'https://api.sunbit.com/sampling/api/v1/sampling',
    },
  },
  'oregon-staging': {
    apiUrl: 'https://api.sunbit.in/loan-application-service',
    datadog: {
      ...datadogParameters,
      proxy: 'https://api.sunbit.in/application-data/',
    },
    mixpanel: {
      token: mixpanelToken,
      debug: true,
    },
    launchDarklyKey: '670feb5032155b08729a5570',
    launchDarkly: {
      experiment: {
        flagName: 'payment-plans',
      },
    },
  },
  'oregon-prod': {
    apiUrl: 'https://api.sunbit.com/loan-application-service',
    fingerprintjs: {
      token: 'jRJ6Bdd3OtOMWqeOmSiG',
      endpoint: 'https://fp.sunbit.com',
    },
    i18n: {
      debug: false,
    },
    mixpanel: {
      proxyURL: 'https://mixpanel-proxy.sunbit.com',
      token: mixpanelToken,
      debug: false,
      optOutTracking: false,
    },
    datadog: {
      ...datadogParameters,
      proxy: 'https://api.sunbit.com/application-data/',
    },
    sampling: {
      endpoint: 'https://api.sunbit.com/sampling/api/v1/sampling',
    },
    launchDarklyKey: '670feb1de220fc0804984c34',
    launchDarkly: {
      experiment: {
        flagName: 'payment-plans',
      },
    },
  },
};
